// Import: Middleware Action & Custom Types
import {
  CLEAN_PURCHASE_ORDER_LIST_IPB,
  CLEAN_PURCHASE_ORDER_LIST_IPB_ERROR,
} from '_models/redux/types';

// Action function
export const cleanPurchaseOrderListClean = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_PURCHASE_ORDER_LIST_IPB,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_PURCHASE_ORDER_LIST_IPB_ERROR,
      payload: undefined,
    });
  }
};
